<div class="__sudo-content">

  <!-- Close button (top right) -->
  <button
    class="__close-button"
    type="button"
    (click)="onCancel$.next()"
    mat-icon-button>
    <mat-icon>close</mat-icon>
  </button>

  <mat-icon fontSet="material-icons-outlined" class="__title-icon">lock</mat-icon>

  <zef-form
      [state]="state.formState"
      (submit)="onSubmit$.next()">

      <zef-scrollbar maxHeight="calc(80vh - 80px)">

        <!-- Header -->
        <zui-form-section
          class="__form-section"
          separatorSize="small"
          separatorSpacing="small">

          <span *zuiFormSectionTitle>
            This action requires elevated permissions. <br/>Please re-authenticate to continue.
          </span>

          <span *zuiFormSectionDesc>
            After successful authentication, you'll remain in sudo mode for a limited time,
            allowing you to perform multiple sensitive operations without re-authenticating.
          </span>

        </zui-form-section>

        <div class="__inner-content">

          <!-- Auth method toggle buttons -->
          <div class="__auth-method-switcher">
            @for (method of availableMethods(); track method.type) {
              <button
                type="button"
                class="__mode-button"
                [class.is-active]="state.formState.controls.authMethod.value === method.type"
                mat-button
                (click)="onAuthMethodChange$.next(method.type)">
                <mat-icon fontSet="material-icons-outlined">{{ method.icon }}</mat-icon>
                {{ method.label }}
              </button>
            }
          </div>

          <!-- Dynamic content based on selected method -->
          <div class="__auth-content  fx:pt-1">

            <!-- Password -->
            @if (state.formState.controls.authMethod.value === 'password') {
              <p class="__signed-in-as">Signed in as <strong>{{ state.userInfo?.email }}</strong></p>

              <!-- Password managers pick the saved login by the username next to the password field. -->
              <input
                hidden
                type="email"
                name="username"
                autocomplete="username"
                readonly
                [value]="state.userInfo?.email ?? ''" />

              <zef-form-field last>
                <mat-form-field color="accent" class="fx:w-100">
                  <mat-label>Password</mat-label>
                  <input
                    matInput
                    id="sudo-password"
                    name="password"
                    type="password"
                    [ngrxFormControlState]="state.formState.controls.password"
                    autocomplete="current-password" />
                </mat-form-field>
              </zef-form-field>
            }

            <!-- TOTP -->
            @if (state.formState.controls.authMethod.value === 'totp') {
              <zef-form-field last>
                <mat-form-field color="accent" class="fx:w-100">
                  <mat-label>6-Digit Code</mat-label>
                  <input
                    matInput
                    type="text"
                    placeholder="000000"
                    [ngrxFormControlState]="state.formState.controls.totpCode"
                    autocomplete="one-time-code" />
                </mat-form-field>
              </zef-form-field>
            }

            <!-- Recovery Code -->
            @if (state.formState.controls.authMethod.value === 'recovery') {
              <zef-form-field last>
                <mat-form-field color="accent" class="fx:w-100">
                  <mat-label>Recovery Code</mat-label>
                  <input
                    matInput
                    type="text"
                    placeholder="10-character code"
                    [ngrxFormControlState]="state.formState.controls.recoveryCode"
                    autocomplete="one-time-code" />
                </mat-form-field>
              </zef-form-field>
            }

            <!-- WebAuthn -->
            @if (state.formState.controls.authMethod.value === 'webauthn') {}

          </div>
        </div>

      </zef-scrollbar>

      <!-- Submit buttons (outside scrollbar, always visible) -->
      <div class="__buttons">
        @if (state.formState.controls.authMethod.value === 'password') {
          <zef-progress-error full [key]="submitPasswordKey">
            <button
              mat-flat-button
              color="accent"
              type="submit"
              class="c-button--full"
              [disabled]="state.formState.isInvalid">
              Verify Password
            </button>
          </zef-progress-error>
        }

        @if (state.formState.controls.authMethod.value === 'totp') {
          <zef-progress-error full [key]="submitTOTPKey">
            <button
              mat-flat-button
              color="accent"
              type="submit"
              class="c-button--full"
              [disabled]="state.formState.isInvalid">
              Verify TOTP Code
            </button>
          </zef-progress-error>
        }

        @if (state.formState.controls.authMethod.value === 'recovery') {
          <zef-progress-error full [key]="submitTOTPKey">
            <button
              mat-flat-button
              color="accent"
              type="submit"
              class="c-button--full"
              [disabled]="state.formState.isInvalid">
              Verify Recovery Code
            </button>
          </zef-progress-error>
        }

        @if (state.formState.controls.authMethod.value === 'webauthn') {
          <zef-progress-error full [key]="startWebAuthnKey">
            <button
              mat-flat-button
              color="accent"
              type="button"
              class="c-button--full"
              (click)="onSubmit$.next()">
              <mat-icon>fingerprint</mat-icon>&nbsp;Use Security Key / Passkey
            </button>
          </zef-progress-error>
        }
      </div>

    </zef-form>

</div>
